import * as React from "react"
import styled from 'styled-components/macro'
import Title from "../../common/Title";
import Subtitle from "../../common/Subtitle";
import Link from "../../common/Link"
import { keyframes } from "styled-components";
import {createRef, useEffect, useRef, useState} from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import LRCLogo from '../../images/loopring-logo.svg'
import LINKLogo from '../../images/assets/chainlink-logo.svg'
import FARMLogo from '../../images/assets/harvest-finance-logo.svg'
import ETHLogo from '../../images/assets/ETH-logo.svg'
import BTCLogo from '../../images/assets/bitcoin-logo.svg'
import FRINLogo from '../../images/assets/FRIN-logo.jpg'
import DAILogo from '../../images/assets/DAI-logo.svg'
import USDCLogo from '../../images/assets/USDC-logo.svg'
import GMXLogo from '../../images/assets/gmx-logo-circle.png'
import DPXLogo from '../../images/assets/dpx-logo.png'
import ARBLogo from '../../images/assets/arb-logo.svg'
import MIMLogo from '../../images/assets/MIM-logo.png'
import GRAILLogo from '../../images/assets/GRAIL-logo.png'
import MAGICLogo from '../../images/assets/MAGIC-logo.png'

const BlueChipSectionWrapper = styled.div`
  width: 100%;
  color: #f9f9f9;
  margin-top: 100px;
  padding-top: 100px;
  padding-bottom: 90px;
  background: #f4f4ff;
  color: black;
`

const BlueChipSectionInner = styled.div`
  width: calc(100% - 40px);
  padding: 0 20px;
  max-width: 1100px;
  margin: 0 auto;
  
  @media screen and (max-width: 880px) {
    max-width: 480px;
    padding: 0;
  }
`

const GraphicWrapper = styled.div`
  width: 25%;
  display: inline-block;
  vertical-align: top;
  position: relative;
  
  @media screen and (max-width: 1400px) {
    width: 26%;
    margin-left: 6%;
    margin-right: -6%;
    margin-top: 2%;
  }
  
  @media screen and (max-width: 1200px) {
    width: 34%;
  }
  
  @media screen and (max-width: 1000px) {
    margin-top: 100px;
    margin-left: 3%;
    margin-right: -2%;
    width: 30%;
  }
  
  @media screen and (max-width: 880px) {
    width: 100%;
    transform: translateY(400px);
    margin: -228px 0 0 0;
  }
`

const GraphicInner = styled.div`

  @media screen and (max-width: 1200px) {
    width: 200px;
    height: 200px;
    margin: 0 auto;
    position: relative;
  }
  
  @media screen and (max-width: 1100px) {
    margin-top: 40px;
  }
  
  @media screen and (max-width: 1000px) {
    margin-top: -10px;
  }
  
  @media screen and (max-width: 880px) {
    width: 130px;
    height: 130px;
  }
}
`

/*const carousel = keyframes`
  from {
    transform: translate(100px, 100px) scale(1);
    z-index: 5;
    animation-timing-function: ease-out;
    filter: drop-shadow(9px 9px 16px rgba(0, 0, 0, 0.5));
  }
  8% {
    z-index: 4;
    animation-timing-function: ease-out;
  }
  25% {
    z-index 3;
    transform: translate(0, 0) scale(0.75);
    animation-timing-function: ease-in;
  }
  50% {
    z-index: 0;
    transform: translate(100px, 100px) scale(0.6);
    animation-timing-function: ease-out;
    filter: drop-shadow(3px 3px 8px rgba(0, 0, 0, 0.5));
  }
  75% {
    z-index: 3;
    transform: translate(200px, 200px) scale(0.75);
    animation-timing-function: ease-in;
    filter: drop-shadow(6px 6px 12px rgba(0, 0, 0, 0.5));
  }
  87% {
    z-index: 4;
    animation-timing-function: ease-in;
  }
  to {
    transform: translate(100px, 100px) scale(1);
    z-index: 5;
    animation-timing-function: ease-out;
    filter: drop-shadow(9px 9px 16px rgba(0, 0, 0, 0.5));
  }
`

const carousel880 = keyframes`
  from {
    transform: translateX(180px) scale(1);
    z-index: 5;
    animation-timing-function: ease-out;
    box-shadow: 9px 9px 16px 3px rgba(0, 0, 0, 0.5);
  }
  8% {
    z-index: 4;
    animation-timing-function: ease-out;
  }
  25% {
    z-index 3;
    transform: translateX(0) scale(0.75);
    animation-timing-function: ease-in;
  }
  50% {
    z-index: 0;
    transform: translateX(180px) scale(0.6);
    animation-timing-function: ease-out;
    box-shadow: 3px 3px 8px 3px rgba(0, 0, 0, 0.5);
  }
  75% {
    z-index: 3;
    transform: translateX(360px) scale(0.75);
    animation-timing-function: ease-in;
    box-shadow: 6px 6px 12px 3px rgba(0, 0, 0, 0.5);
  }
  87% {
    z-index: 4;
    animation-timing-function: ease-in;
  }
  to {
    transform: translateX(180px) scale(1);
    z-index: 5;
    animation-timing-function: ease-out;
    box-shadow: 9px 9px 16px 3px rgba(0, 0, 0, 0.5);
  }
`

const carousel780 = keyframes`
  from {
    transform: translateX(150px) scale(1);
    z-index: 5;
    animation-timing-function: ease-out;
    box-shadow: 9px 9px 16px 3px rgba(0, 0, 0, 0.5);
  }
  8% {
    z-index: 4;
    animation-timing-function: ease-out;
  }
  25% {
    z-index 3;
    transform: translateX(0) scale(0.75);
    animation-timing-function: ease-in;
  }
  50% {
    z-index: 0;
    transform: translateX(150px) scale(0.6);
    animation-timing-function: ease-out;
    box-shadow: 3px 3px 8px 3px rgba(0, 0, 0, 0.5);
  }
  75% {
    z-index: 3;
    transform: translateX(300px) scale(0.75);
    animation-timing-function: ease-in;
    box-shadow: 6px 6px 12px 3px rgba(0, 0, 0, 0.5);
  }
  87% {
    z-index: 4;
    animation-timing-function: ease-in;
  }
  to {
    transform: translateX(150px) scale(1);
    z-index: 5;
    animation-timing-function: ease-out;
    box-shadow: 9px 9px 16px 3px rgba(0, 0, 0, 0.5);
  }
`

const carousel580 = keyframes`
  from {
    transform: translateX(125px) scale(1);
    z-index: 5;
    animation-timing-function: ease-out;
    box-shadow: 9px 9px 16px 3px rgba(0, 0, 0, 0.5);
  }
  8% {
    z-index: 4;
    animation-timing-function: ease-out;
  }
  25% {
    z-index 3;
    transform: translateX(0) scale(0.75);
    animation-timing-function: ease-in;
  }
  50% {
    z-index: 0;
    transform: translateX(125px) scale(0.6);
    animation-timing-function: ease-out;
    box-shadow: 3px 3px 8px 3px rgba(0, 0, 0, 0.5);
  }
  75% {
    z-index: 3;
    transform: translateX(250px) scale(0.75);
    animation-timing-function: ease-in;
    box-shadow: 6px 6px 12px 3px rgba(0, 0, 0, 0.5);
  }
  87% {
    z-index: 4;
    animation-timing-function: ease-in;
  }
  to {
    transform: translateX(125px) scale(1);
    z-index: 5;
    animation-timing-function: ease-out;
    box-shadow: 9px 9px 16px 3px rgba(0, 0, 0, 0.5);
  }
`

const carousel450 = keyframes`
  from {
    transform: translateX(100px) scale(1);
    z-index: 5;
    animation-timing-function: ease-out;
    box-shadow: 9px 9px 16px 3px rgba(0, 0, 0, 0.5);
  }
  8% {
    z-index: 4;
    animation-timing-function: ease-out;
  }
  25% {
    z-index 3;
    transform: translateX(0) scale(0.75);
    animation-timing-function: ease-in;
  }
  50% {
    z-index: 0;
    transform: translateX(100px) scale(0.6);
    animation-timing-function: ease-out;
    box-shadow: 3px 3px 8px 3px rgba(0, 0, 0, 0.5);
  }
  75% {
    z-index: 3;
    transform: translateX(200px) scale(0.75);
    animation-timing-function: ease-in;
    box-shadow: 6px 6px 12px 3px rgba(0, 0, 0, 0.5);
  }
  87% {
    z-index: 4;
    animation-timing-function: ease-in;
  }
  to {
    transform: translateX(100px) scale(1);
    z-index: 5;
    animation-timing-function: ease-out;
    box-shadow: 9px 9px 16px 3px rgba(0, 0, 0, 0.5);
  }
`

const ImageWrapper = styled.div`
  width: 100%;
  max-width: 800px;
  text-align: center;
  position: relative;
  height: 200px;
  margin-top: -60px;
  margin-left: 90px;

  img {
    position: absolute;
    animation-name: ${carousel};
    animation-duration: 20s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    width: 120px;
    height: 120px;
    margin-left: -290px;

    :nth-of-type(1) {
      animation-delay: 0s;
    }

    :nth-of-type(2) {
      animation-delay: -4s;
    }

    :nth-of-type(3) {
      animation-delay: -8s;
    }

    :nth-of-type(4) {
      animation-delay: -12s;
    }

    :nth-of-type(5) {
      animation-delay: -16s;
    }
  }

  @media screen and (max-width: 880px) {
    margin: 100px auto -90px;

    img {
      width: 180px;
      height: 180px;
      margin-left: -270px;
      border-radius: 15px;
      animation-name: ${carousel880};
    }
  }

  @media screen and (max-width: 780px) {
    margin: 100px auto -120px;

    img {
      width: 150px;
      height: 150px;
      margin-left: -225px;
      border-radius: 12px;
      animation-name: ${carousel780};
    }
  }

  @media screen and (max-width: 580px) {
    margin: -65px auto -60px;
    transform: translateY(125px);

    img {
      width: 125px;
      height: 125px;
      margin-left: -187px;
      border-radius: 10px;
      animation-name: ${carousel580};
    }
  }

  @media screen and (max-width: 450px) {
    margin: -50px auto -110px;

    img {
      width: 100px;
      height: 100px;
      margin-left: -150px;
      border-radius: 10px;
      animation-name: ${carousel450};
    }
  }
`*/

const Curve = styled.div`
  background: none;
  position: absolute;
  width: 200px;
  height: 200px;
  border: 4px solid transparent;
  border-bottom-color: black;
  left: 0;
  border-radius: 50%;
  transform: rotate(45deg);
  
  @media screen and (max-width: 1400px) {
    width: 160px;
    height: 160px;
  }
  
  @media screen and (max-width: 880px) {
    width: 125px;
    height: 125px;
  }
`

const Arrowhead = styled.div`
  width: 28px;
  height: 28px;
  position: absolute;
  background: none;
  border-top: 4px solid black;
  border-left: 4px solid black;
  border-radius: 2px;
  background: none;
  left: -14px;
  top: 105px;
  transform: rotate(45deg);
  
  @media screen and (max-width: 1400px) {
    top: 85px;
  }
  
  @media screen and (max-width: 880px) {
    top: 70px;
  }
`

const ArrowheadRight = styled(Arrowhead)`
  transform: rotate(-135deg);
  left: 190px;
  top: 70px;
  
  @media screen and (max-width: 1400px) {
    left: 150px;
    top: 50px;
  }
  
  @media screen and (max-width: 880px) {
    top: 32px;
    left: 115px;
  }
`

const TopTokenAnimation = keyframes`
  from {
    left: -40px;
    top: 20px;
    opacity: 0;
  }

  10% {
    left: -20px;
    top: -20px;
    opacity: 1;
  }
  
  90% {
    left: -20px;
    top: -20px;
    opacity: 1;
  }
  
  to {
    left: 20px;
    top: -70px;
    opacity: 0;
  }
`

const BottomTokenAnimation = keyframes`
  from {
    right: 20px;
    top: 110px;
    opacity: 0;
  }

  10% {
    right: 40px;
    top: 130px;
    opacity: 1;
  }
  
  90% {
    right: 40px;
    top: 130px;
    opacity: 1;
  }
  
  to {
    right: 60px;
    top: 150px;
    opacity: 0;
  }
`

const BottomTokenAnimation1400 = keyframes`
  from {
    left: 132px;
    top: 85px;
    opacity: 0;
  }

  10% {
    left: 112px;
    top: 105px;
    opacity: 1;
  }
  
  90% {
    left: 112px;
    top: 105px;
    opacity: 1;
  }
  
  to {
    left: 92px;
    top: 125px;
    opacity: 0;
  }
`

const BottomTokenAnimation600 = keyframes`
  from {
    left: 120px;
    top: 73px;
    opacity: 0;
  }

  10% {
    left: 100px;
    top: 93px;
    opacity: 1;
  }
  
  90% {
    left: 100px;
    top: 93px;
    opacity: 1;
  }
  
  to {
    left: 80px;
    top: 113px;
    opacity: 0;
  }
`

const TokenLogo = styled.div`
  position: absolute;
  width: 100px;
  height: 100px;
  border-radius: 50%;

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
  
  @media screen and (max-width: 1400px) {
    width: 80px;
    height: 80px;
  }
  
  @media screen and (max-width: 880px) {
    width: 60px;
    height: 60px;
  }
`

const TokenLeft = styled(TokenLogo)`
  animation-name: ${TopTokenAnimation};
  animation-duration: ${({ firstRun }) => firstRun ? '2.7s' : '3.7s'}; 
  animation-timing-function: ease-in-out; 
  animation-delay: 0.3s;
  animation-iteration-count: 1;
  
  left: 30px;
  top: -80px;
  opacity: 0;
`

const TokenRight = styled(TokenLogo)`
  animation-name: ${BottomTokenAnimation};
  animation-duration: ${({ firstRun }) => firstRun ? '2.7s' : '3.7s'}; 
  animation-timing-function: ease-in-out; 
  animation-delay: 0.3s;
  animation-iteration-count: 1;
  
  right: 40px;
  top: 130px;
  opacity: 0;
  
  @media screen and (max-width: 1400px) {
    animation: ${BottomTokenAnimation1400} ${({ firstRun }) => firstRun ? '2.7s' : '3.7s'} ease-in-out 1;
    animation-delay: 0.3s;
    
    right: unset;
    left: 112px;
    top: 110px;
  }
  
  @media screen and (max-width: 880px) {
    animation: ${BottomTokenAnimation600} ${({ firstRun }) => firstRun ? '2.7s' : '3.7s'} ease-in-out 1;
    animation-delay: 0.3s;
    
    left: 112px;
    top: 110px;
  }
`

const ContentWrapper = styled.div`
  width: 75%;
  display: inline-block;
  vertical-align: top;
  
  @media screen and (max-width: 1400px) {
    width: 71%;
  }
  
  @media screen and (max-width: 1200px) {
    width: 66%;
  }
  
  @media screen and (max-width: 1000px) {
    width: 69%;
  }
  
  @media screen and (max-width: 880px) {
    width: 100%;
  }
`

const SpinnerWrapper = styled.div`
  vertical-align: top;
  width: fit-content;
  margin-left: 25px;
  font-size: 38px;
  font-weight: 500;
  line-height: 60px;
  height: 60px;
  position: relative;
  
  @media screen and (max-width: 1400px) {
    font-size: 32px;
    line-height: 54px;
    height: 54px;
  }
  
  @media screen and (max-width: 1000px) {
    transform: translate(calc(16% - 275px), 0px);
    margin-left: 0;
    width: 600px;
    text-align: center;
  }
  
  @media screen and (max-width: 880px) {
    width: fit-content;
    transform: /*translate(calc(16% - 205px), 0px);*/none;
    margin-bottom: 250px;
    margin-left: auto;
    margin-right: auto;
    font-size: 32px;
    line-height: 54px;
    height: 54px;
  }
`

const MarginTradeTextWrapper = styled.div`
  display: inline-block;
  
  @media screen and (max-width: 880px) {
    transform: translateY(10px);
  }
`

const MarginTradeSpinnerBreak = styled.br`
  display: none;
  
  @media screen and (max-width: 880px) {
    display: block;
  }
`

const Asset = styled.span`
  color: #6da8ff;
  font-weight: 600;
  font-size: 40px;
  line-height: 60px;
  height: 60px;
`

const Content = styled.div`
  width: calc(100% - 50px);
  padding: 15px 25px 25px;
  max-width: 990px;
  
  @media screen and (max-width: 1100px) {
    padding: 15px 25px;
  }
  
  @media screen and (max-width: 880px) {
    padding: 0;
    width: 100%;
  }
`

const LineBreak = styled.br`
  display: none;
  
  @media screen and (max-width: 1100px) {
    display: block;
  }
`

const AgainstTextSpacer = styled.div`
  display: none;
  
  @media screen and (max-width: 880px) {
    visibility: hidden;
    display: inline;
    position: relative;
  }
`

const AgainstDesktopText = styled.div`
  display: inline;
  
  @media screen and (max-width: 880px) {
    display: none;
  }
`

const AgainstText = styled.div`

  @media screen and (max-width: 880px) {
    position: absolute;
    z-index: 9999;
    top: -6px;
    display: block;
    visibility: visible;
    left: 0;
  }
`

const SpinnerOuterOuter = styled.div`
  position: absolute;
  display: inline-block;
  top: -1px;
  
  @media screen and (max-width: 880px) {
    top: 52px;
  }
`

const SpinnerOuter = styled.div`
  height: 70px;
  display: inline-block;
  overflow: hidden;
  position: relative;
  color: #6da8ff;
  color: #2172E5;
  font-weight: 600;
  font-size: 46px;
  transition: all 1s ease-in-out;
  width: fit-content;
  margin-left: 10px;
  
  @media screen and (max-width: 1400px) {
    font-size: 40px;
    height: 60px;
  }
  
  @media screen and (max-width: 880px) {
    font-size: 32px;
    height: 54px;
  }
`

const SpinnerInner = styled.div`
  margin-top: 1px;
  transition: all 0.7s ease-in-out;
  font-weight: 600;
`

const ShadowBox = styled.div`
  content: '';
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  //box-shadow: inset 0px 20px 8px -10px #1e1c29, inset 0px -20px 8px -10px #1e1c29;
  box-shadow: inset 0px 20px 8px -10px #f4f4ff, inset 0px -20px 8px -10px #f4f4ff;
  z-index: 99;
`

const slideUp = keyframes`
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-300px);
  }
`

const slideUp1400 = keyframes`
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-270px);
  }
`

const slideUp600 = keyframes`
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-270px);
  }
`

const slideDown = keyframes`
  from {
    transform: translateY(-300px);
  }
  to {
    transform: translateY(0);
  }
`

const slideDown1400 = keyframes`
  from {
    transform: translateY(-270px);
  }
  to {
    transform: translateY(0);
  }
`

const slideDown600 = keyframes`
  from {
    transform: translateY(-270px);
  }
  to {
    transform: translateY(0);
  }
`

const Currency = styled.div`
  animation: ${props => props.direction === 'UP' ? slideUp : slideDown} 1s ease-in-out 1;
  animation-fill-mode: forwards;
  z-index: 1;
  width: fit-content;
  
  @media screen and (max-width: 1400px) {
    animation: ${props => props.direction === 'UP' ? slideUp1400 : slideDown1400} 1s ease-in-out 1;
    animation-fill-mode: forwards;
  }
  
  @media screen and (max-width: 880px) {
    animation: ${props => props.direction === 'UP' ? slideUp600 : slideDown600} 1s ease-in-out 1;
    animation-fill-mode: forwards;
  }
`

const CurrencyStatic = styled.div`
  width: fit-content;
`

const WidthGetterCurrency = styled.div`
  display: inline-block;
  width: fit-content;
  font-weight: 600;
  font-size: 46px;
  position: absolute;
  visibility: hidden;
  
  @media screen and (max-width: 1400px) {
    font-size: 40px;
  }
  
  @media screen and (max-width: 880px) {
    font-size: 32px;
  }
`

const Spacer = styled.div`
  display: inline-block;
  width: ${props => props.width}px;
  transition: all 1s ease-in-out;
`

const Small = styled.div`
  display: inline-block;
  position: absolute;
  z-index: 100;
  font-weight: 400;
  font-size: 15px;
  color: #606375;
  line-height: 18px;
  cursor: pointer;
  width: 60px;
  margin-top: 15px;
  text-align: left;
  
  svg {
    height: 16px;
    margin-bottom: -3px;
    margin-left: -2px;
  }
  
  :hover {
    color: #d5d6e1;
  }
  
  @media screen and (max-width: 1400px) {
    font-size: 14px;
    line-height: 15px;
    margin-top: 13px;
  }
  
  @media screen and (max-width: 880px) {
    display: none;
  }
`

const TokenIcon = styled.div`
  background: white;
  border-radius: 50%;
  width: 40px;
  height: 40px;
`

const ComingSoonText = styled.div`
  color: #606375;
  font-size: 15px;
  line-height: 16px;
  margin-top: 12px;
  display: inline-block;
  vertical-align: top;
`

const TOKEN_LIST = ['ETH', 'USDC', 'DAI', 'LINK', 'ARB', 'GMX', 'WBTC', 'MAGIC', 'MIM', 'GRAIL']
const TOKEN_IMAGE_LIST = {
  'ETH': ETHLogo,
  'USDC': USDCLogo,
  'DAI': DAILogo,
  'LINK': LINKLogo,
  'ARB': ARBLogo,
  'GMX': GMXLogo,
  'WBTC': BTCLogo,
  'MAGIC': MAGICLogo,
  'MIM': MIMLogo,
  'GRAIL': GRAILLogo,
}

// markup
const BlueChipSection = () => {
  const [fromList, setFromList] = useState(['ARB'])
  const [toList, setToList] = useState(['GMX'])
  const [toOffset, setToOffset] = useState(100)
  const [fromOffset, setFromOffset] = useState(100)
  const [firstRun, setFirstRun] = useState(true)
  const [clickedComingSoon, setClickedComingSoon] = useState(false)
  const toDivRef = useRef(null)
  const fromDivRef = useRef(null)

  useEffect(() => {
    setInterval(() => {
      setFromList(oldTokenList => {
        if (oldTokenList.length === 1) {
          const fullList = TOKEN_LIST.slice()
          const newList = oldTokenList.concat(fullList.filter(token => token !== oldTokenList[0]).sort(() => 0.5 - Math.random()).slice(0,5))

          setToList(oldTokenList => {
            const fullList = TOKEN_LIST.slice()
            if (firstRun) setFirstRun(false)
            return oldTokenList.concat(fullList.filter(token => token !== oldTokenList[0] && token !== newList[newList.length - 1]).sort(() => 0.5 - Math.random()).slice(0,5)).reverse()
          })
          if (firstRun) setFirstRun(false)
          return newList
        }
        else {
          const lastList = oldTokenList.slice()
          const newList = lastList.splice(lastList.length - 1,lastList.length)

          setToList(oldTokenList => {
            const lastList = oldTokenList.slice()
            return [lastList[0]]
          })
          if (firstRun) setFirstRun(false)
          return newList
        }
      })
    }, 2000)

    const fromResizeObserver = new ResizeObserver((entries) => {
      const divRefOffset = fromDivRef.current ? fromDivRef.current.offsetWidth : 100

      setFromOffset(divRefOffset + 20)
    })
    fromResizeObserver.observe(fromDivRef.current)

    const toResizeObserver = new ResizeObserver((entries) => {
      const divRefOffset = toDivRef.current ? toDivRef.current.offsetWidth : 100

      setToOffset(divRefOffset + 20)
    })
    toResizeObserver.observe(toDivRef.current)

    return () => {
      toResizeObserver.disconnect()
      fromResizeObserver.disconnect()
    }
  }, [])

  return (
    <BlueChipSectionWrapper>
      <BlueChipSectionInner>
      <GraphicWrapper>
        <GraphicInner>
          <Curve />
          <Arrowhead />
          <TokenLeft key={fromList[fromList.length - 1]} firstRun={firstRun}>
            <img src={TOKEN_IMAGE_LIST[fromList[fromList.length - 1]]} />
          </TokenLeft>
          <Curve style={{ transform: 'rotate(225deg)' }} />
          <ArrowheadRight />
          <TokenRight key={toList[0]} firstRun={firstRun}>
            <img src={TOKEN_IMAGE_LIST[toList[0]]} />
          </TokenRight>
          {/*<ImageWrapper>
            <img src={ETHLogo} />
            <img src={LINKLogo} />
            <img src={LRCLogo} />
            <img src={FARMLogo} />
            <img src={BTCLogo} />
          </ImageWrapper>*/}
        </GraphicInner>
      </GraphicWrapper>
      <ContentWrapper>
        <SpinnerWrapper>
          <MarginTradeTextWrapper>Margin trade</MarginTradeTextWrapper>
          <MarginTradeSpinnerBreak />
          <WidthGetterCurrency ref={fromDivRef}>{fromList[toList.length - 1]}</WidthGetterCurrency>
          <WidthGetterCurrency ref={toDivRef}>{toList[0]}</WidthGetterCurrency>
          <SpinnerOuterOuter>
            <SpinnerOuter>
              <SpinnerInner>
                <ShadowBox />
                {fromList.length === 1 ? (
                  <CurrencyStatic>{fromList[0]}</CurrencyStatic>
                ) : (
                  fromList.map((token, index) => <Currency direction={'UP'}>{token}</Currency>)
                )}
              </SpinnerInner>
            </SpinnerOuter>
          </SpinnerOuterOuter>
          <Spacer width={fromOffset} />
          <AgainstDesktopText>against</AgainstDesktopText>
          <AgainstTextSpacer>against<AgainstText>against</AgainstText></AgainstTextSpacer>
          <SpinnerOuterOuter>
            <SpinnerOuter>
              <SpinnerInner>
                <ShadowBox />
                {toList.length === 1 ? (
                  <CurrencyStatic>{toList[0]}</CurrencyStatic>
                ) : (
                  toList.map((token, index) => <Currency key={token} direction={'DOWN'}>{token}</Currency>)
                )}
              </SpinnerInner>
            </SpinnerOuter>
          </SpinnerOuterOuter>
          <Spacer width={toOffset} />
          <a href={`https://app.dolomite.io/trade/${fromList[0]}/${toList[0]}`}><Small>Trade<br/>Now<ArrowForwardIcon /></Small></a>
        </SpinnerWrapper>
        <Content>
          <Title>
            Powerful DEX pair<LineBreak /> margin trading.
          </Title>
          <Subtitle>
            In the past, DEX margin trading has limited you to trading ETH and WBTC against stablecoins. Now with Dolomite you can margin trade many of your favorite DeFi assets against stablecoins or even other DeFi assets.
          </Subtitle>
          <Link text={'Start trading'} dest={'https://app.dolomite.io/trade/USDC/ETH'} breakWidth={350} />
        </Content>
      </ContentWrapper>
      </BlueChipSectionInner>
    </BlueChipSectionWrapper>
  )
}

export default BlueChipSection
